import type { RouteObject } from 'react-router';

import { lazy, Suspense } from 'react';
import { Outlet, Navigate } from 'react-router';

import { paths } from 'src/routes/paths';
import { AdminProtectedRoute } from 'src/routes/AdminProtectedRoute';

import AdminLayout from 'src/layouts/admin';

const AdminLoginPage = lazy(() => import('src/pages/admin/login'));
const AdminActivitiesPage = lazy(() => import('src/pages/admin/activities'));
const AdminActivityEditPage = lazy(() => import('src/pages/admin/activity-edit'));
const AdminCareersPage = lazy(() => import('src/pages/admin/careers'));
const AdminCareerEditPage = lazy(() => import('src/pages/admin/career-edit'));

export const adminRoutes: RouteObject[] = [
  {
    path: paths.admin.login,
    element: (
      <Suspense fallback={null}>
        <AdminLoginPage />
      </Suspense>
    ),
  },
  {
    element: <AdminProtectedRoute />,
    children: [
      {
        element: (
          <AdminLayout>
            <Outlet />
          </AdminLayout>
        ),
        children: [
          { path: paths.admin.root, element: <Navigate to={paths.admin.activities} replace /> },
          {
            path: '/admin/activities',
            element: (
              <Suspense fallback={null}>
                <AdminActivitiesPage />
              </Suspense>
            ),
          },
          {
            path: '/admin/activities/:id',
            element: (
              <Suspense fallback={null}>
                <AdminActivityEditPage />
              </Suspense>
            ),
          },
          {
            path: '/admin/careers',
            element: (
              <Suspense fallback={null}>
                <AdminCareersPage />
              </Suspense>
            ),
          },
          {
            path: '/admin/careers/:id',
            element: (
              <Suspense fallback={null}>
                <AdminCareerEditPage />
              </Suspense>
            ),
          },
        ],
      },
    ],
  },
];
